import { useTranslation } from 'next-i18next';
import { ArrowPathIcon, PlayIcon } from '@heroicons/react/24/outline';

import { Modal, ModalContent, Button as ButtonV2, Heading } from '@restworld/ui-ds-base';

interface ResumeOnboardingModalProps {
  isOpen: boolean;
  onContinue: () => void;
  onStartFresh: () => void;
}

/**
 * Modal that prompts the user to continue from where they left off
 * or start fresh when returning to the onboarding flow with existing data.
 */
export function ResumeOnboardingModal({ isOpen, onContinue, onStartFresh }: ResumeOnboardingModalProps) {
  const { t } = useTranslation('restaurant-onboarding');

  const titleEl = (
    <Heading color="neutral" align="center" className="leading-[30px] px-4 sm:px-0">
      {t('resume_onboarding_modal_title')}
    </Heading>
  );

  const footerEl = (
    <div className="flex flex-col justify-center items-center gap-3 w-full">
      <ButtonV2 variant="primary" fullwidth StartIcon={PlayIcon} onClick={onContinue}>
        {t('resume_onboarding_modal_continue_button')}
      </ButtonV2>
      <ButtonV2 variant="tertiary" fullwidth StartIcon={ArrowPathIcon} onClick={onStartFresh}>
        {t('resume_onboarding_modal_start_fresh_button')}
      </ButtonV2>
    </div>
  );

  return (
    <Modal open={isOpen} onOpenChange={(v) => !v && onContinue()} disableOverlayClose>
      <ModalContent
        showCloseIcon={false}
        className="w-full max-w-[640px] lg:max-w-screen-sm"
        title={titleEl}
        footer={footerEl}
      >
        <div className="flex flex-col justify-center items-center gap-5 w-full text-center mt-6">
          <Heading size={5} weight="medium" color="neutral" className="whitespace-pre-line">
            {t('resume_onboarding_modal_description')}
          </Heading>
        </div>
      </ModalContent>
    </Modal>
  );
}

export default ResumeOnboardingModal;
